<script setup lang="ts">

import { usePresentation } from '@/modules/Presentation/Types';
import { useLead } from "../../Types/Lead";
import { useForm, Form, Rules } from "@library/Components/Forms/Form/v2";
import { Map } from '../../Types/Map';

import EmailTextField from '@library/Components/Forms/EmailTextField/EmailTextField.vue';
import { send } from 'vite';
import { Outcome } from '../../Types/LeadOptions';

const lead = useLead();
const form = await useForm( lead );
const presentation = usePresentation();

presentation.backgroundImage = '/images/sample/gkr-watermark.png';

const advance = () => presentation.goto( Map.ChooseDojo );

const sendInformationEmailAndReset = () =>
{
    lead.outcome = Outcome.thinkAboutIt;
    lead.save( true );
    presentation.goto( Map.Close );
}

</script>

<template>

    <Page>

        <div class="flex flex-col gap-4 w-full text-xl px-32">

            <Form 
                :form="form"
                v-slot="{ model, state }">

                <div class="flex flex-col gap-4">

                    <p>
                        Would you be interested to receive more information by email so you can decide later?
                    </p>

                    <div class="flex gap-4">

                        <TextField
                            label="First Name"
                            v-model="model.firstName"
                            :rules="Rules.required()"
                        />

                        <TextField
                            label="Last Name"
                            v-model="model.lastName"
                            :rules="Rules.required()"
                        />

                    </div>
                    
                    <EmailTextField 
                        label="Email"
                        v-model="model.email"
                        required
                    />

                    <div class="flex gap-6 justify-center">

                        <TouchButton
                            :disabled="state.isValid == false"
                            variant="button"
                            @click="() => sendInformationEmailAndReset()">
                            Send Information Pack
                        </TouchButton>

                        <TouchButton
                            @click="() => presentation.reset()">
                            No thank you
                        </TouchButton>

                        <TouchButton 
                            flat
                            @click="() => advance()">
                            Actually, tell me more
                        </TouchButton>

                    </div>

                </div>

            </Form>
            
        </div>

    </Page>

</template>